<template>
  <div class="collaborateur">
    <div :class="['profile-wrapper', { 'has-survol': hasSurvolImage }]" ref="profileWrapper">
      <div class="survol" :style="survolBackground"></div>
      <div class="principale" :style="principaleBackground"></div>
    </div>
    <div class="infos">
      <p>
        {{ collaborator.acf.informations.prenom_nom }}
        <span v-if="currentLangInfo">
          <br>
          <span v-html="currentLangInfo"></span>
        </span>
      </p>
      <a
        v-if="collaborator.acf.informations.email"
        :href="`mailto:${collaborator.acf.informations.email}`"
        class="smalltxt"
      >
        {{ collaborator.acf.informations.email }}<span></span>
      </a>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  props: {
    collaborator: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentlang() {
      return store.state.i18n.locale;
    },
    currentLangInfo() {
      const info = this.collaborator.acf.informations;
      if (this.currentlang === 'de') {
        return info.infos_de;
      }
      return info.infos_fr;
    },
    principaleBackground() {
      const url = this.collaborator.acf.photos.principale;
      return url ? { backgroundImage: `url(${url})` } : {};
    },
    survolBackground() {
      const url = this.collaborator.acf.photos.au_survol;
      return url ? { backgroundImage: `url(${url})` } : {};
    },
    hasSurvolImage() {
      return !!this.collaborator.acf.photos.au_survol;
    },
  },
  mounted() {
    this.addTouchListeners();
  },
  beforeDestroy() {
    this.removeTouchListeners();
  },
  methods: {
    addTouchListeners() {
      const profileWrapper = this.$refs.profileWrapper;
      if (profileWrapper && this.hasSurvolImage) {
        profileWrapper.addEventListener('touchstart', this.handleTouchStart);
        profileWrapper.addEventListener('touchend', this.handleTouchEnd);
      }
    },
    removeTouchListeners() {
      const profileWrapper = this.$refs.profileWrapper;
      if (profileWrapper && this.hasSurvolImage) {
        profileWrapper.removeEventListener('touchstart', this.handleTouchStart);
        profileWrapper.removeEventListener('touchend', this.handleTouchEnd);
      }
    },
    handleTouchStart() {
      this.toggleTouchHover(true);
    },
    handleTouchEnd() {
      this.toggleTouchHover(false);
    },
    toggleTouchHover(state) {
      const profileWrapper = this.$refs.profileWrapper;
      if (profileWrapper) {
        profileWrapper.classList.toggle('touch-hover', state);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.profile-wrapper {
  position: relative;
  aspect-ratio: 2/3;
  margin-bottom: 20px;
  background-color: #eee;
  overflow: hidden;
  .principale,
  .survol {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: absolute;
    top: 0;
    left: 0;
  }
  .principale {
    transition: all 0.6s;
  }
  .survol {
    transform: scale(1.1);
    transition: all 0.6s;
  }
  &.has-survol {
    cursor: pointer;
  }
  &.has-survol:hover,
  &.has-survol.touch-hover {
    .principale {
      opacity: 0;
      transform: scale(1.1);
    }
    .survol {
      transform: scale(1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/Collaborateur.vue